<template>
  <!-- 自定义字段 -->
  <div v-if="enableCustomerTable" class="custom-column">
    <form-items v-if="showType === 'form'" :columns="columns" :label-width="labelWidth" :icon-width="iconWidth">
      <form-item v-for="(item, idx) in customerColumnListAll" :key="idx" :label="item.columnLabel" :col-span="item.columnSpan" :required="item.columnRequire === 1" :name="item.columnName" error-message="数据不能为空">
        <!-- 图片 -->
        <image-upload v-model="dataDetail[item.columnName]" v-if="item.columnTypeDisplay === 'image'" :limit="parseInt(item.columnSetting)" @dataChange="changeData" :show-folder-manage="true"/>
        <!-- 下拉选项 -->
        <el-select v-model="dataDetail[item.columnName]" v-else-if="item.columnTypeDisplay === 'select'" @change="changeData">
          <el-option v-for="(option, idx) in item.columnSettingOption" :key="idx" :label="option.value" :value="option.code"/>
        </el-select>
        <!-- 下拉选项，多选 -->
        <el-select v-model="dataDetail[item.columnName + 'Multi']" v-else-if="item.columnTypeDisplay === 'selectMulti'" multiple @change="changeSelectMulti(item.columnName)">
          <el-option v-for="(option, idx) in item.columnSettingOption" :key="idx" :label="option.value" :value="option.code"/>
        </el-select>
        <!-- 文本 -->
        <el-input v-model="dataDetail[item.columnName]" v-else-if="item.columnTypeDisplay === 'text'" @change="changeData" :placeholder="`请输入${item.columnLabel},最多字${item.columnSetting}字`"/>
        <!-- 日期 -->
        <yq-date-picker v-model="dataDetail[item.columnName]" v-else-if="item.columnTypeDisplay === 'date'" type="date" format="yyyy-MM-dd" placeholder="选择日期" style="width: 100%" @change="changeData"/>
        <!-- 日期+时间 -->
        <yq-date-picker v-model="dataDetail[item.columnName]" v-else-if="item.columnTypeDisplay === 'dateTime'" type="datetime" format="yyyy-MM-dd hh:mm:ss" placeholder="选择日期时间"  style="width: 100%" @change="changeData"/>
        <!-- 勾选 -->
        <div v-else-if="item.columnTypeDisplay === 'switch'">
          <span>{{item.columnSetting}}</span>
          <el-switch v-model="dataDetail[item.columnName]"  :active-value="1" :inactive-value="0" @change="changeData"/>
        </div>
        <!-- 数字 -->
        <el-input-number v-model="dataDetail[item.columnName]" v-else-if="item.columnTypeDisplay === 'number'"  style="width: 100%" @change="changeData"  :placeholder="`请输入${item.columnLabel}`"/>
        <!-- 小数 -->
        <el-input-number v-model="dataDetail[item.columnName]" v-else-if="item.columnTypeDisplay === 'double'"  style="width: 100%" @change="changeData"  :placeholder="`请输入${item.columnLabel},最多支持${item.columnSetting}位小数位`"/>
      </form-item>
    </form-items>
    <yq-table v-else-if="showType === 'table'" :data="customerColumnListAll">
      <yq-table-column :label="tableTitle[0]" prop="columnLabel" width="200px">
        <template v-slot="{row}"></template>
      </yq-table-column>
      <yq-table-column :label="tableTitle[1]" prop="content">
        <template v-slot="{row}">
          <span v-if="row.columnTypeDisplay === 'switch'">{{row.columnSetting}}</span>
        </template>
      </yq-table-column>
      <yq-table-column :label="tableTitle[2]" prop="result" width="100px">
        <template v-slot="{row}">
          <!-- 图片 -->
          <image-upload v-model="dataDetail[row.columnName]" v-if="row.columnTypeDisplay === 'image'" :limit="parseInt(row.columnSetting)" @dataChange="changeData" :show-folder-manage="true"/>
          <!-- 下拉选项 -->
          <el-select v-model="dataDetail[row.columnName]" v-else-if="row.columnTypeDisplay === 'select'" @change="changeData">
            <el-option v-for="(option, idx) in row.columnSettingOption" :key="idx" :label="option.value" :value="option.code"/>
          </el-select>
          <!-- 下拉选项，多选 -->
          <el-select v-model="dataDetail[row.columnName + 'Multi']" v-else-if="row.columnTypeDisplay === 'selectMulti'" multiple @change="changeSelectMulti(row.columnName)">
            <el-option v-for="(option, idx) in row.columnSettingOption" :key="idx" :label="option.value" :value="option.code"/>
          </el-select>
          <!-- 文本 -->
          <el-input v-model="dataDetail[row.columnName]" v-else-if="row.columnTypeDisplay === 'text'" @change="changeData" :placeholder="`请输入${row.columnLabel},最多字${row.columnSetting}字`"/>
          <!-- 日期 -->
          <yq-date-picker v-model="dataDetail[row.columnName]" v-else-if="row.columnTypeDisplay === 'date'" type="date" format="yyyy-MM-dd" placeholder="选择日期" style="width: 100%" @change="changeData"/>
          <!-- 日期+时间 -->
          <yq-date-picker v-model="dataDetail[row.columnName]" v-else-if="row.columnTypeDisplay === 'dateTime'" type="datetime" format="yyyy-MM-dd hh:mm:ss" placeholder="选择日期时间"  style="width: 100%" @change="changeData"/>
          <!-- 勾选 -->
          <div v-else-if="row.columnTypeDisplay === 'switch'">
            <el-switch v-model="dataDetail[row.columnName]"  :active-value="1" :inactive-value="0" @change="changeData"/>
          </div>
          <!-- 数字 -->
          <el-input-number v-model="dataDetail[row.columnName]" v-else-if="row.columnTypeDisplay === 'number'"  style="width: 100%" @change="changeData"  :placeholder="`请输入${row.columnLabel}`"/>
          <!-- 小数 -->
          <el-input-number v-model="dataDetail[row.columnName]" v-else-if="row.columnTypeDisplay === 'double'"  style="width: 100%" @change="changeData"  :placeholder="`请输入${row.columnLabel},最多支持${row.columnSetting}位小数位`"/>
        </template>
      </yq-table-column>
    </yq-table>
  </div>
</template>

<script>

import commonApi from "@/api/commonApi";
import FormTag from "@/components/h5/layout/FormTag.vue";
import FormItems from "@/components/h5/layout/FormItems.vue";
import FormItem from "@/components/h5/layout/FormItem.vue";
import ImageUpload from "@/components/h5/image/ImageUpload.vue";
import YqDatePicker from "@/components/h5/date/YqDatePicker.vue";
import {watch} from "vue";
import YqTable from "@/components/h5/table/YqTable.vue";
import YqTableColumn from "@/components/h5/table/YqTableColumn.vue";
export default {
  props: {
    appName: {default: ""}, // 业务应用
    pageName: {default: ""}, // 页面名称
    showType: {default: "form"}, // 显示类型，form或table
    tableTitle: {default: () => ["名称", "内容", "结果"]}, // 表格标题
    modelValue: {
      type: Object,
      default: () => {
        return {}
      }
    },
    // 以下是form-items的属性
    columns: {default: "3"},
    labelWidth: {default: "4rem"},
    iconWidth: {default: "1rem"},
  },
  name: "",
  components: {
    YqTableColumn,
    YqTable,
    ImageUpload, YqDatePicker,
    FormTag, FormItems, FormItem
  },
  data() {
    return {
      enableCustomerTable: false, // 是否支持自定义字段功能
      customerColumnListAll: [], // 自定义字段列表
      dataDetail: {},
    };
  },
  created() {
    // 是否支持自定义功能
    commonApi.queryCustomerTableAble({appName: this.appName, pageName: this.pageName}).then(res => {
      if (res === "1") {
        commonApi.customerTableList(this.pageName).then(list => {
          this.enableCustomerTable = !!list.length;
          for (let i = 0; i < list.length; i++) {
            if (list[i].columnTypeDisplay === 'select' || list[i].columnTypeDisplay === 'selectMulti') {
              list[i].columnSettingOption = JSON.parse(list[i].columnSetting);
            }
          }
          this.customerColumnListAll = list;
          this.initData();
        });
      }
    });
    this.dataDetail = this.modelValue.customerForm || {};
    watch(() => this.modelValue, () => {
      this.initData();
    })
  },
  methods: {
    initData() {
      this.dataDetail = this.modelValue.customerForm || {};
      // 如果有selectMulti选项
      for (let i = 0; i < this.customerColumnListAll.length; i++) {
        if (this.customerColumnListAll[i].columnTypeDisplay === 'selectMulti') {
          if (this.dataDetail[this.customerColumnListAll[i].columnName]) {
            this.dataDetail[this.customerColumnListAll[i].columnName + 'Multi'] = this.dataDetail[this.customerColumnListAll[i].columnName].split(",");
          }
        }
      }
    },
    // 自定义字段数据改变时，更新父组件的modelValue
    changeData() {
      this.$emit("update:modelValue", {
        ...this.modelValue,
        customerForm: this.dataDetail
      });
    },
    // 多选框，将array转成string
    changeSelectMulti(column) {
      let value = this.dataDetail[column + 'Multi'];
      this.dataDetail[column] = value.join(",");
      this.changeData();
    }
  }
};
</script>

<style lang="scss" scoped>
.custom-column{
  :deep(.el-table){
    position: relative;
  }
}
</style>